var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Button as AntButton } from "antd";
/**
 * Forwards its ref through to the underlying element. Ant's own Button does,
 * and callers that need to measure or point at a button (a tour coachmark, a
 * tooltip anchor) get the button itself rather than a wrapper that only
 * approximates its box.
 */
var Button = React.forwardRef(function (props, ref) { return _jsx(AntButton, __assign({}, props, { ref: ref })); });
Button.displayName = "Button";
export default Button;
